export default "__VITE_ASSET__BDhGBN1K__"